import React, { useEffect, useState } from 'react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 59);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev <= 0 ? 14 * 60 + 59 : prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="flex flex-col items-center my-2.5 mb-5" data-id="element-1">
      <p className="text-xs tracking-[1.5px] uppercase text-white/45 mb-2.5 font-dmsans" data-id="element-2">
        ⚡ Esta oferta vence en
      </p>
      <div className="flex gap-2.5" data-id="element-3">
        <div className="flex flex-col items-center" data-id="element-4">
          <div className="bg-white/5 border border-gold/30 rounded-md font-playfair text-[32px] font-black text-gold-light px-3.5 py-2 min-w-[58px] text-center leading-none" data-id="element-5">
            {String(minutes).padStart(2, '0')}
          </div>
          <div className="text-[10px] tracking-[1px] uppercase text-white/35 mt-1.5 font-dmsans" data-id="element-6">
            Min
          </div>
        </div>
        <div className="text-2xl text-gold self-center mb-4 font-playfair" data-id="element-7">
          :
        </div>
        <div className="flex flex-col items-center" data-id="element-8">
          <div className="bg-white/5 border border-gold/30 rounded-md font-playfair text-[32px] font-black text-gold-light px-3.5 py-2 min-w-[58px] text-center leading-none" data-id="element-9">
            {String(seconds).padStart(2, '0')}
          </div>
          <div className="text-[10px] tracking-[1px] uppercase text-white/35 mt-1.5 font-dmsans" data-id="element-10">
            Seg
          </div>
        </div>
      </div>
    </div>;
}